// Module
var code = "<mn-procedure-table details=\"vm.item.details\" readonly=\"true\" has-code=\"true\" has-price=\"true\" has-qte=\"true\" flex></mn-procedure-table>";
// Exports
module.exports = code;